import { BenBase } from './BenBase'
import { BenHash } from './BenHash'
import { BenQuery } from './BenQuery'
const lang = window['$BenQuery']
let _id = 0
export class BenModal {
  static async init($dom, app, { type = 'win' as 'win' | 'full' | 'image', easyClose = true } = {}) {
    await BenQuery.nextTick()
    document.documentElement.classList.add('scroll-locked-modal')
    const $modal = BenQuery.createElement('div', { classList: ['c-modal'] })
    const title = BenQuery.getData('modalTitle') || ''
    $modal.setAttribute('type', type)
    $modal.innerHTML = `<div class="window"><div class="header"><b class=title>${title}</b><div class="back"><svg><use xlink:href="#icon-close"></use></svg></div></div> <div class="body"></div></div>`
    const $body = $modal.querySelector('.body')!
    const $back = $modal.querySelector('.back')!
    const $window = $modal.querySelector('.window')
    $modal.addEventListener('click', (e) => {
      if (!easyClose) return
      if (e.target !== $modal && e.target !== $window) return
      window.history.back()
    })
    $back.addEventListener('click', (e) => {
      window.history.back()
    })
    document.body.appendChild($modal)
    $body.appendChild($dom)
    requestAnimationFrame(() => {
      BenBase.initQueryList(app)
    })
    $modal.classList.add('show')
    BenHash.pushModal(async () => {
      $modal.remove()
      await BenQuery.sleep(30)
      const $modalNow = document.querySelector('.c-modal')
      if (!$modalNow) document.documentElement.classList.remove('scroll-locked-modal')
    })
  }
}
